import { useState } from "react";
import usePromotion from "./use_promotion";
import Statistics from "./statistics";
import PromotionTable from "./promotion_table";

function Promotion() {
  const promotion = usePromotion();
  const [showExpired, setShowExpired] = useState(false);
  return (
    <div className="w-full">
      <Statistics showExpired={showExpired} {...promotion.statsQuery} />
      <PromotionTable
        showExpired={showExpired}
        setShowExpired={setShowExpired}
        {...promotion}
      />
    </div>
  );
}

export default Promotion;
